import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import {
  CompanyNameCell,
  getFullName,
  getUserPlaceholder,
  renderValue
} from "utils/renderCompanyCell";
import { format } from "date-fns";

const historyColumns = () => {
  const columnHelper = createColumnHelper();

  return [
    columnHelper.accessor("user_id", {
      header: "User ID",
      size: 80,
      headerClassName: "table-header mono",
      enableSorting: false,
      cellClassName: "table-cell mono",
      cell: (info) => <>{renderValue(info.getValue())}</>
    }),

    columnHelper.accessor((row) => row.name, {
      id: "name",
      header: "Name",
      size: 200,
      headerClassName: "table-header",
      cellClassName: "table-cell",
      enableSorting: false,
      cell: (info) => {
        const row = info.row.original?.user;
        const fullName = renderValue(getFullName(row));
        return (
          <CompanyNameCell
            logo={row?.profile_image || getUserPlaceholder()}
            name={fullName}
            title={fullName}
          />
        );
      }
    }),

    columnHelper.accessor("search_term", {
      header: "Search Term",
      size: 160,
      headerClassName: "table-header",
      enableSorting: false,
      cellClassName: "table-cell",
      cell: (info) => (
        <div className="truncate-text" title={renderValue(info.getValue())}>
          {renderValue(info.getValue())}
        </div>
      )
    }),

    columnHelper.accessor("created_at", {
      header: "Created At",
      size: 207,
      headerClassName: "table-header",
      enableSorting: false,
      cellClassName: "table-cell",
      cell: (info) => (
        <>
          {renderValue(
            format(new Date(info.getValue()), "MMM dd, yyyy h:mm a")
          )}
        </>
      )
    })
  ];
};

export default historyColumns;
